<template >
  <b-modal v-if="$auth.isAuthenticated"
    class="modal-stations"
    ref="modal"
    centered
    :visible="true"
    size="lg"
    @hidden="onModalHidden"
    :no-close-on-esc="!canBeClosed"
    :no-close-on-backdrop="!canBeClosed"
    :footer-class="isCreateNewStation ? 'footer__open' : ''"
  >
    <template slot="modal-header">
      <div class="modal-header-stations">
        <h1 class="modal-header-title" v-if="isEditing">{{ Translations.sections.stations.title }}</h1>
        <h1 class="modal-header-title" v-if="!isEditing">{{ Translations.sections.station.title }}</h1>
        <div v-if="stations && stations.length > 1 && isEditing" class="modal-header-search">
          <i class="fas fa-search"></i>
          <input :value="search" @input="handleSearch" type="text" placeholder="Search..." />
        </div>
      </div>
    </template>
    <template slot="modal-footer">
      <div class="create-section">
        <span class="text" @click="editMode">
          <i class="fas fa-plus" v-show="!isCreateNewStation" v-tooltip="{data: 'Create new station', arrowPosition: 'top'}"></i>
          <i class="fas fa-arrow-left" v-show="isCreateNewStation"></i>
        </span>
        <div class="btn__root" v-if="!isEditing" style="right: 0px; position:absolute">
          <Button @click.prevent="createStation" empty="empty" :disabled="pendingCreation">
            <span v-if="!pendingCreation">Save</span>
            <span v-else><i class="fas fa-sync fa-spin"></i></span>
          </Button>
        </div>
<!--        <div v-show="isCreateNewStation" class="root_input">-->
<!--          <div class="root_input__form">-->
<!--            <input type="text" class="input" placeholder="Station name" v-model="nameStation" />-->
<!--            <b-form-select v-model="labelCategoryID" :options="Constants.labelCategoryID" class="space"></b-form-select>-->
<!--            <div class="control__btn">-->
<!--              <div class="label__root">-->
<!--                <input type="checkbox" id="isRedirect" v-model="isRedirect">-->
<!--                <label class="label__text" for="isRedirect">Do you want to be redirected to the created station ?</label>-->
<!--              </div>-->
<!--              <div class="btn__root">-->
<!--                <Button @click.prevent="createStation" empty="empty" :disabled="pendingCreation">-->
<!--                  <span v-if="!pendingCreation">Create</span>-->
<!--                  <span v-else><i class="fas fa-sync fa-spin"></i></span>-->
<!--                </Button>-->
<!--              </div>-->
<!--            </div>-->
<!--          </div>-->
<!--        </div>-->
      </div>
    </template>
    <template>
      <ul class="stations" v-if="isEditing">
        <li class="station" v-for="station in filteredStations" :key="station.uid">
<!--          <div v-if="isEditing && station.uid === currentStationUid" class="edit-mode">-->
<!--            <input type="text" class="input" v-model="stationEditedField">-->
<!--            <Button :empty="true" class="btn__save" @click.prevent="saveEditField(station)">save</Button>-->
<!--          </div>-->
          <button
            class="station-toggle"
            v-on:click.prevent="onStationClick(station)"
            v-tooltip="{data: `Category : ${getLabelType(station.labelCategoryID)}`, arrowPosition: 'top'}"
          >
            {{ station.name }}
          </button>
          <div class="control__root" >
            <button
              :disabled="station.name.search('MCU-') === 0"
              @click="editStation(station)"
              v-tooltip="{data: 'edit this station', arrowPosition: 'right'}"
              class="default"
            >
              <i class="fas fa-edit"></i>
            </button>
            <button
              :disabled="station.name.search('MCU-') === 0"
              @click="deleteStation(station)"
              v-tooltip="{data: 'Delete this station', arrowPosition: 'right'}"
              class="default"
            >
              <i class="fas fa-trash"></i>
            </button>

            <button
                :disabled="station.id === 0"
                @click="duplicateStation(station)"
                v-tooltip="{data: 'Duplicate this station', arrowPosition: 'right'}"
                class="default"
            >
              <i class="fas fa-copy"></i>
            </button>
          </div>
        </li>
      </ul>
      <ul v-else>
                <div class="root_input">
                  <div class="root_input__form">
                    <b-form-group
                        id="group-name"
                        :label="Translations.sections.station.name"
                        label-for="name"
                        :label-cols="4"
                    >
                    <b-form-input type="text" class="input"  autocomplete="off" :placeholder="Translations.sections.station.name" v-model="nameStation" />
                      <div style="color:red" v-if="isDuplicateStationName"> You must choose a different station name </div>
                    </b-form-group>
                    <b-form-group
                        id="group-categories"
                        :label="Translations.sections.station.LabelCategory"
                        label-for="name"
                        :label-cols="4"
                        >
                    <b-form-select v-model="labelCategoryID" :options="Constants.labelCategoryID" class="space"  :disabled="categoryCheck()"></b-form-select>
                    </b-form-group>
                    <b-form-group id="group-targets" :label="'Targets'" label-for="targets" :label-cols="4">
                      <!--                        <span class="detail-label">Targets</span>-->
                      <StyleBadgeList styles=""
                                      :styles="stationData.targets"
                                      ref="styles"
                                      :readOnly="true"
                                      placeholder
                                      @onFocus="onFocus('targets')"
                                      @onBlur="onBlur"
                                      @click.prevent="openParameterSelector('showTargetSelector','modalTargets', [stationData])"
                      />
                      <!--                        <span class="detail-error">This field is required</span>-->
                    </b-form-group>
                    <div >
                      <!--                        <span class="detail-label">Style(s)</span>-->
                      <b-form-group id="group-style" :label="'Styles'" label-for="style" :label-cols="4">
                        <StyleBadgeList
                            :styles="stationData.styles"
                            ref="styles"
                            :readOnly="true"
                            placeholder
                            @onFocus="onFocus('styles')"
                            @onBlur="onBlur"
                            @click.prevent="openParameterSelector('showStyleSelector','modalStyles', [stationData])"
                        />
                        <!--                        <span class="detail-error">This field is required</span>-->
                      </b-form-group>
                    </div>

                    <div v-if="cloneStation" style="display: flex;">
                      <div class="control__btn">
                        <div class="label__root">
                          <input type="checkbox" id="isRedirect" v-model="duplicateBoxes" >
                          <label class="label__text" for="isRedirect">Duplicate boxes and smart boxes</label>
                        </div>
                      </div>
                      <div class="control__btn">
                        <div class="label__root">
                          <input type="checkbox" id="isRedirect" v-model="duplicatePlaylists">
                          <label class="label__text" for="isRedirect">Duplicate playlists</label>
                        </div>
                      </div>
                      <div class="control__btn">
                        <div class="label__root">
                          <input type="checkbox" id="isRedirect" v-model="duplicateTracks">
                          <label class="label__text" for="isRedirect">Duplicate tracks</label>
                        </div>
                      </div>
                    </div>
                    <div v-if="cloneStation" style="display: flex;">
                      <div class="control__btn"  v-if="cloneStation">
                      <div class="label__root">
                        <input type="checkbox" id="duplicateClocks" v-model="duplicateClocks">
                        <label class="label__text" for="duplicateClocks">Duplicate clocks</label>
                      </div>
                    </div>
                    <div class="control__btn"  v-if="cloneStation">
                      <div class="label__root">
                        <input type="checkbox" id="duplicateDayTemplates" v-model="duplicateDayTemplates">
                        <label class="label__text" for="duplicateDayTemplates">Duplicate day templates</label>
                      </div>
                    </div>
                    </div>
                    <div style="display: flex;">
                    <div class="control__btn">
                      <div class="label__root">
                        <input type="checkbox" id="isRedirect" v-model="isRedirect">
                        <label class="label__text" for="isRedirect">I want to be redirected to the created station</label>
                      </div>
                    </div>
                    
                      <div class="control__btn" >
                        <div class="label__root">
                         <span> &nbsp;  &nbsp; &nbsp; &nbsp; &nbsp;&nbsp; &nbsp; &nbsp;</span>
                        </div>
                      </div>

                  </div>
                  </div>
<!--                  <div class="btn__root">-->
<!--                    <Button @click.prevent="createStation" empty="empty" :disabled="pendingCreation">-->
<!--                      <span v-if="!pendingCreation">Create</span>-->
<!--                      <span v-else><i class="fas fa-sync fa-spin"></i></span>-->
<!--                    </Button>-->
<!--                  </div>-->
                </div>
      </ul>
      <p
        class="modal-no-result"
        v-if="filteredStations.length === 0"
      >No stations found</p>
    </template>
    <SelectorStyle
        v-show="viewState.showStyleSelector"
        ref="modalStyles"
        :stationUid="stationData.stationUid"
        :noModalEdit="true"
        @newValue="onNewValueStyles"
        @onHidden="resetModalState('showStyleSelector')"
    />
    <SelectorTargets
        v-show="viewState.showTargetSelector"
        ref="modalTargets"
        :stationUid="stationData.stationUid"
        :noModalEdit="true"
        @newValueTargets="onNewValueTargets"
        @onHidden="resetModalState('showTargetSelector')"
    />
  </b-modal>
</template>

<script>
import Translations from "@/store/translations";
import EventBus from "@/eventbus";
import { mapState, mapActions } from "vuex";
import Button from "@/components/common/Button";
import Constants from "@/store/constants";
import {safeObj} from "@/utils/safeObj";
import StyleBadgeList from "@/components/common/StyleBadgeList";
import SelectorStyle from "@/components/Library/SelectorStyle";
import SelectorCategories from "@/components/Boxes/SelectorCategorie";
import SelectorTargets from "@/components/Boxes/SelectorTarget";
import {HTTP} from "@/utils/http";
export default {
  name: "StationsList",
  components: {Button , StyleBadgeList, SelectorStyle  , SelectorTargets},
  props: {
    currentStation: {
      type: Object,
      default: {}
    },
    canBeClosed: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    ...mapState({
      Translations: () => Translations,
      stations: state => {
        if (!state.stations || !state.stations.items) {
          return [];
        }

        const sortedStations = [...state.stations.items].sort((a, b) => {
          return a.name.localeCompare(b.name);
        });
        return sortedStations;
      }
    }),
    search () {
        return this.$store.state.stationsSearch
    },
    filteredStations () {
        if (this.search.length > 0) {
            return (this.stations || []).filter(station => {
                return station.name.toLowerCase().search(this.search.toLowerCase()) >= 0;
            })
        }

        return this.stations
    }
  },
  data() {
    return {
      isCreateNewStation: false,
      nameStation: '',
      isEditing: true,
      cloneStation: false,
      duplicateBoxes: true,
      duplicatePlaylists : true,
      duplicateTracks : false,
      duplicateClocks : true,
      duplicateDayTemplates : false,
      isDuplicateStationName : false,
      currentStationUid: null,
      currentStationId: null,
      stationEditedField: '',
      labelCategoryID: "",
      isRedirect: true,
      pendingCreation: false,
      Constants,
      stationData: {
        targets: null,
        styles: null,
        stationUid: null,
      },
      viewState: {
        showStyleSelector: false,
        showTargetSelector: false,
      },
    };
  },
  methods: {
    categoryCheck(){
      if(this.stationData.stationUid){
        return true;
      }
      return false;
    },
    editMode(){
      this.stationEditedField = '';
      this.currentStationUid = '';
      this.labelCategoryID = '';
      this.stationEditedField = '';
      this.nameStation = '';
      this.isDuplicateStationName = false;
      this.cloneStation = false;
      this.stationData.stationUid = null;
      this.stationData.targets = null;
      this.stationData.styles = null;
      this.isCreateNewStation =! this.isCreateNewStation;
      this.isEditing =! this.isEditing;

    },
    onFocus(field) {
      this.$set(this.viewState, "fieldFocused", field);
    },
    onBlur() {
      this.$set(this.viewState, "fieldFocused", null);
    },
    openParameterSelector(toggler, selectorName, tracks) {
      if (!tracks || tracks.length === 0) return;
      this.viewState[toggler] = true;

      try {
        var modalSelector = this.$refs[selectorName];

        if (modalSelector) {
          modalSelector.editForTracks(tracks);
        }
      } catch (e) {
        console.log("exc:", e);
      }
    },
    onNewValueTargets(field, value) {
      console.log(field, value);
      this.stationData.targets = value;
    },
    onNewValueStyles(field, value) {
      console.log(field, value);
      this.stationData.styles = value;
    },
    resetModalState(toggler) {

    },
    handleSearch (e) {
      this.$store.dispatch('updateStationsSearch', e.target.value)
    },
    getLabelType(type){
      if (type === 1 || type === 2 || type === 3 || type === 4 || type === 5 || type === 6 || type === 7 || type === 8 || type === 9 || type === 10){
        return Constants.labelCategoryID.filter(label => label.value === type )[0].text
      }else{
        return Constants.labelCategoryID.filter(label => label.text === type )[0].text
      }

    },
    onStationClick(station) {
      this.hide();
      console.log(this.currentStation)
      console.log(station)
      if ( safeObj(this.currentStation) && this.currentStation.uid === station.uid ) {
        return;
      }
      this.$router.push({
        name: "Dashboard",
        params: { stationUid: station.uid }
      });
    },
    show() {
      this.$refs.modal.show();
    },
    hide() {
      this.$refs.modal.hide();
    },
    onModalHidden() {
      EventBus.$emit("hideStationsList");
    },
    async createStation(){

      if ((this.stationData.currentName === this.nameStation) && this.cloneStation){
          this.isDuplicateStationName = true;
      } else {
      this.isDuplicateStationName = false;

      let api, data;
      let styles = this.TransformDataStyles(this.stationData.styles);
      let targets = this.TransformDataTargets(this.stationData.targets);
      this.pendingCreation = true
      if(this.cloneStation){
        if(!this.duplicateBoxes){
          this.duplicateClocks = this.duplicateBoxes;
          this.duplicateDayTemplates = this.duplicateBoxes;
        }
        if(!this.duplicateClocks){
          this.duplicateDayTemplates = this.duplicateClocks;
        }
        api = "api/station/duplicate"
        data ={
          stationId: this.currentStationId,
          name: this.nameStation,
          labelCategoryID: this.labelCategoryID,
          styles:  styles,
          targets:  targets,
          duplicateBoxes: this.duplicateBoxes,
          duplicateClocks: this.duplicateClocks,
          duplicateDayTemplates: this.duplicateDayTemplates,
          duplicatePlaylists: this.duplicatePlaylists,
          duplicateTracks: this.duplicateTracks,
        }
      }else{
        api ="api/station/rename";
         data ={
           stationUid: this.currentStationUid,
           name: this.nameStation,
           labelCategoryID: this.labelCategoryID,
           styles:  styles,
           targets:  targets
         }
      }

      if(this.currentStationUid) {
        HTTP.post( api,data
            ).then(this.redirection)
            .catch(error => {
              this.pendingCreation = false
              this.$store.dispatch('Toasts/addToast', {
                title: 'Error occurred',
                message: e.data.errors[0].message,
                type: 'danger'
              });
            })

      } else {
        if(!!this.nameStation && !!this.labelCategoryID){
          try {
            const response = await this.$store.dispatch('createStation',  {
              name: this.nameStation,
              labelCategoryID: this.labelCategoryID,
              styles:  styles,
              targets:  targets
            });

            this.nameStation = '';
            this.labelCategoryID = '';

            if (this.isRedirect){
              setTimeout(() => {
                this.pendingCreation = false
                this.onStationClick(response)
              }, 1000)
            } else {
              this.pendingCreation = false
            }
          } catch (e) {
            this.pendingCreation = false
            this.$store.dispatch('Toasts/addToast', {
              title: 'Error occurred',
              message: e.data.errors[0].message,
              type: 'danger'
            });
          }
        }
      }

    }

    },
    redirection(response){
      if (this.isRedirect && this.currentStationUid){
        setTimeout(() => {
          this.pendingCreation = false
          this.onStationClick(response.data.dataItem)
        }, 1000)
      } else {
        this.pendingCreation = false
      }
    },
    resetFields(){
      this.isEditing = false;
      this.stationEditedField = '';
      this.currentStationUid = '';
    },
    TransformDataStyles(data){
      if(data) {
        let array = [];
        for (let i = 0; i < data.length; i++) {
          array.push({'styleId': data[i].id});
        }
        return array;
      }
    },
    TransformDataTargets(data){
      if(data) {
        let array = [];
        for (let i = 0; i < data.length; i++) {
          array.push({'targetId': data[i].id});
        }
        return array;
      }
    },
    editStation(station){
      console.log('editStation')
      // clean local state
      this.resetFields();
      this.isCreateNewStation =! this.isCreateNewStation;
      // set new state
      // this.isEditing = true;
      this.currentStationUid = station.uid;
      this.currentStationName = station.Name;
      this.stationEditedField = station.name;
      HTTP.get("/api/station/" + this.currentStationUid )
          .then(this.getStation)
          .then(function() {
            console.log("End...");
          });
      this.nameStation = station.name;
      this.isEditing = false;
      this.cloneStation = false;
    },
    duplicateStation(station){
      this.editStation(station);
      this.cloneStation = true;
    },

    async getStation(response) {
      console.log(response);
      this.labelCategoryID = response.data.dataItem.labelCategoryID;
      this.stationData.styles = response.data.dataItem.styles;
      this.stationData.targets = response.data.dataItem.targets;
      this.stationData.stationUid = response.data.dataItem.uid;
      this.stationData.currentName = response.data.dataItem.name;
      this.currentStationId = response.data.dataItem.id;

    },
    async deleteStation (station) {
      if (confirm(`Are you sure that you want to delete "${station.name}"?`)) {
        console.log('delete', station)
        try {
          const response = await this.$store.dispatch('deleteStation', {
            stationUid: station.uid
          })

          console.log('response', response)
        } catch (e) {
          console.log('failed to delete', e)
        } finally {

        }
      }
    },
    async saveEditField(station){
      if (!!this.stationEditedField ){
        let res = await this.$store.dispatch('editStation', {
          stationUid: station.uid,
          name: this.stationEditedField
        });

        if (res.uid){
          ((this.stations ||[]).find(x => x.uid == res.uid) || {}).name = res.name;
        }
        this.resetFields()
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-header-stations {
  display: flex;
  flex-direction: column;
  width: 100%;
}

.modal-header-search {
  display: flex;
  align-items: center;
  position: relative;
  width: calc(100% + 30px);
  margin: 15px -15px -12px -15px;
  padding: 0 15px;
  border-top: 1px solid #e9ecef;
  i {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.2);
    margin-right: 10px;
    margin-bottom: -2px;
  }
  input {
    flex-grow: 1;
    display: block;
    padding: 12px 0 11px;
    border-bottom: 0;
    color: #292c33;
    font-size: 14px;
    line-height: 1;
  }
}

.stations {
  overflow-y: auto;
  margin: -15px;
  padding: 0 15px;
  width: calc(100% + 30px);
  height: 200px;
  max-height: calc(100vh - 200px);
}

.station {
  position: relative;
  height: 37px;
  padding: 0;
  cursor: auto;
  justify-content: space-between;
  overflow-x: auto;
  + .station {
    border-top: 1px solid #d2d2d2;
  }
}

.station-toggle {
  display: flex;
  align-items: center;
  border: 0;
  padding: 10px 15px 10px 0;
  border-radius: 0;
  background: none;
  color: #292c33;
  font-size: 14px;
  text-transform: none;
  transition: color 0.2s ease-in-out;
}

.modal-no-result {
  font-weight: 400;
  color: #292c33;
  font-size: 16px;
}

.create-section{
  cursor: pointer;
  position: relative;
  width: 100%;
  display: flex;
  align-items: center;
  height: 30px;
  .text{
    margin-left: 10px;
    margin-right: 10px;
    i{
      color: var(--COLOR_BRAND);
    }
  }
  .root_input{
    display: flex;
    justify-content: flex-start;
    margin-left: auto;
    flex: 0 0 90%;
    height: 100%;
    .root_input__form{
      line-height: 1.6;
      line
      .space{
        margin: 10px 0;
      }
      /*display: flex;*/
      /*flex-direction: column;*/
    }
  }
  .input{
    padding-bottom: 0;
    margin-right: 10px;
    flex: 0 0 80%;
    width: 100%;
  }
}
  .control__root{
    cursor: pointer;

    button {
      color: #0003;

      &:hover, &:focus {
        color: #292c33;
      }
    }

    button  {
      margin-left: 15px;
    }
  }
  .edit-mode{
    //position: relative;
    flex: 0 0 70%;
    .input{
      width: 100%;
    }
    .btn__save{
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      right: 40px;
    }
  }
  .modal-footer  {
    transition: all .3s ease;
    height: 60px;
    align-items: flex-start;
    &.footer__open{
      height: 180px;
    }
  }
  .control__btn{
    padding-bottom: 15px;
    padding-top: 15px;
    display: flex;
    flex-grow: 3;
    justify-content: space-between;
    .label__root{
      display: flex;
      align-items: flex-start;
      .label__text{
        width: 95%;
        margin-left: 15px;
        font-size: 14px;
      }
    }
  }

</style>
